import React from 'react'
import { Modal } from 'antd'
import { injectIntl } from 'react-intl'
import queryStringSyncEnhancer from 'services/queryStringSyncEnhancer'
import classnames from 'classnames'
import LegalInfo from './LegalInfo'
import style from './style.module.scss'

class LegalInfoModal extends React.Component {
  showModal = () => this.props.updateQueryParam({ showLegal: true })

  closeModal = () => this.props.updateQueryParam({ showLegal: null, legalDocId: null })

  render() {
    const {
      intl: { formatMessage },
      getQueryParams,
      label
    } = this.props

    const queryParams = getQueryParams()
    const { showLegal } = queryParams

    return (
      <>
        <button
          className={classnames(style.openModalButton, this.props.className)}
          onClick={this.showModal}
          type="button"
        >
          {label || formatMessage({ id: 'footer.legal-information' })}
        </button>
        <Modal
          className={style.modal}
          title={formatMessage({ id: 'footer.legal-information' })}
          visible={showLegal}
          onCancel={this.closeModal}
          footer={null}
          destroyOnClose
        >
          <LegalInfo />
        </Modal>
      </>
    )
  }
}

export default queryStringSyncEnhancer(injectIntl(LegalInfoModal))
